import React from 'react';
import { Link } from 'react-router-dom';

/*
 * Button (SPEC §8). variant: 'accent' | 'dark' | 'ghost'.
 * Renders as:
 *   - <Link>   for internal route paths ("/structural")
 *   - <a>      for anchors/hash ("/#contact") and external ("https://…")
 *   - <button> when no href is given
 */
export default function Button({
  variant = 'accent',
  href,
  children,
  className = '',
  type = 'button',
  ...rest
}) {
  const cls = `btn btn--${variant}${className ? ` ${className}` : ''}`;

  if (href) {
    const isHash = href.includes('#');
    const isExternal = /^https?:\/\//i.test(href);
    if (isHash || isExternal) {
      const ext = isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {};
      return (
        <a className={cls} href={href} {...ext} {...rest}>
          {children}
        </a>
      );
    }
    return (
      <Link className={cls} to={href} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <button className={cls} type={type} {...rest}>
      {children}
    </button>
  );
}
